import { PRODUCT_OFFERINGS } from '../types';

export function ProductOfferingsRow() {
  return (
    <section className="ed-section-card">
      <div className="ed-section-header ed-offerings-header">
        <div className="ed-section-header-left">
          <span className="ed-section-icon ed-offerings-icon" aria-hidden="true">★</span>
          <h2 className="ed-section-title ed-offerings-title">Product Offerings & Other Services</h2>
        </div>
      </div>
      <div className="ed-offerings-scroll">
        {PRODUCT_OFFERINGS.map((offering) => (
          <article key={offering.title} className="ed-offering-card">
            <div className="ed-offering-card-watermark ed-offering-card-watermark--1" aria-hidden="true">
              <img src={offering.iconAsset} alt="" />
            </div>
            <div className="ed-offering-card-watermark ed-offering-card-watermark--2" aria-hidden="true">
              <img src={offering.iconAsset} alt="" />
            </div>
            <div className="ed-offering-card-icon">
              <img src={offering.iconAsset} alt="" />
            </div>
            <h3 className="ed-offering-card-title">{offering.title}</h3>
            <p className="ed-offering-card-desc">{offering.description}</p>
            <a href={offering.learnMoreUrl} target="_blank" rel="noopener noreferrer" className="ed-offering-learn-more">
              Learn More <span aria-hidden="true">↗</span>
            </a>
          </article>
        ))}
      </div>
    </section>
  );
}
